import { gql } from "@apollo/client";

export const GET_INFO_ASISTENCIAL_VISITA = gql`
query informacionAsistencialVisita($idEvaluacion: Int!) {
   informacionAsistencialVisita(idEvaluacion: $idEvaluacion){
      success
      valorEsperado{
        talla
        diagnostico
        enfermedadOncologica
        pesoActual
        gradoDesnutricion
        diagnosticoNutricional
        soporteNutricional
        fase
        requiereCapacitacion
        idDatosGeneralesRI
        modoInfusion
        llevaBomba
        flujo
        hidratacion
        indicacionHidratacion
        formaPreparacion
        indicacionEspecial
        indicacionComentario
        suplementoVitaminico
        suplemento
        indicacionSuplemento
        tipoAcceso
        cambioSNG
        bAPMagistral
        volumen
        horasAdministracion
        expansion
        idComboVisitaValorExpansion
        conexionSemana
        conexionSemanaMagistral
        bAPEstandar
        insumoBAP
        indicacion
        selladoCateter
        tipoCateter
        ubicacion
        lumenes
        volumenMagistral
        duracionMesetaMagistral
        cantidadEscalonesMagistral
        volumenEstandar
        duracionMesetaEstandar
        cantidadEscalonesEstandar
        idComboVisitaValorProducto
      }
    }
}`;

const ID_TIPO_BAP_ESTANDAR = 334;
const ID_TIPO_BAP_MAGISTRAL = 335;

export const parseInfoAsistencial = (data) => {
  const {
    enfermedadOncologica,
    pesoActual,
    talla,
    requiereCapacitacion,
    llevaBomba,
    cambioSNG,
    diasConexion,
    ...rest
  } = data?.informacionAsistencialVisita?.valorEsperado || {};
  return {
    ...rest,
    enfermedadOncologica: enfermedadOncologica ? "SI" : "NO",
    pesoActual: pesoActual ? `${pesoActual} kg` : "-",
    talla: talla ? `${talla} m` : "-",
    requiereCapacitacion: requiereCapacitacion ? "SI" : "NO",
    llevaBomba: llevaBomba ? "SI" : "NO",
    cambioSNG: cambioSNG ? "SI" : "NO"
  };
};